import { render } from "./infocards.vue?vue&type=template&id=979462f8&scoped=true"
import script from "./infocards.vue?vue&type=script&lang=js"
export * from "./infocards.vue?vue&type=script&lang=js"

import "./infocards.vue?vue&type=style&index=0&id=979462f8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-979462f8"

export default script